/**
 * Shared helper used by both ProtectedRoute (when sending the user to /auth)
 * and Auth.tsx (after a successful login) to compute where the user should
 * land. Centralizing the rule guarantees the fallback is ALWAYS "/" and
 * the two call sites cannot diverge.
 */
export function getRedirectTarget(rawRedirect: string | null | undefined): string {
  if (!rawRedirect) return "/";
  const value = rawRedirect.trim();
  if (!value) return "/";
  // Only allow same-origin, absolute-path redirects to avoid open-redirect vulns.
  // Reject "//" and "/\" prefixes too: some browsers normalize a leading
  // backslash to a forward slash, turning "/\evil.com" into the
  // protocol-relative "//evil.com" once used in a real navigation.
  if (!value.startsWith("/") || /^\/[\\/]/.test(value)) return "/";
  return value;
}

/** Build the /auth URL preserving the attempted path as ?redirect=… */
export function buildAuthUrl(attemptedPath: string): string {
  return `/auth?redirect=${encodeURIComponent(attemptedPath)}`;
}